module.exports = __webpack_public_path__ + "static/media/aboutImage3.77a65a13.png";